import React from 'react';
import { Button } from '../ui/Button';
import { CHECKOUT_BASIC, CHECKOUT_PREMIUM } from '../../data/content';
export function FinalCTA() {
  return <section className="py-24 relative" data-id="element-52" data-mp="5ch9kw23k265">
      <div className="container mx-auto px-4" data-id="element-53" data-mp="3mua4dvg263mg">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-12" data-id="element-54" data-mp="3mti80ien01v4">
          <div className="p-6 rounded-2xl bg-surface border border-line flex flex-col justify-between" data-id="element-55" data-mp="3rrab88kqfaem">
            <div data-id="element-56" data-mp="3drisxvn6n7ut">
              <h2 className="text-lg font-bold text-ink mb-1 flex items-start gap-2" data-id="element-57" data-mp="3dv6mgusmnu9j">
                <span aria-hidden="true" data-id="element-58" data-mp="3hw0b5qdw9d3h">📗</span> MEGA PACK COCINA LISTA
              </h2>
              <p className="text-muted text-sm mb-4" data-id="element-59" data-mp="33wh2mwh67zqn">
                6 Tomos + 6 Bonos · Sistema base completo
              </p>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-60" data-mp="38vtwi16gm72q">
                <span className="text-muted/70 line-through text-sm" data-id="element-61" data-mp="1242ng560h9dx">$52.000 ARS</span>
                <span className="text-3xl font-display font-bold text-ink" data-id="element-62" data-mp="171b6s92wbjgr">
                  $19.990 <span className="text-sm text-muted font-sans" data-id="element-63" data-mp="q7txzee4g4d5">ARS</span>
                </span>
              </div>
            </div>
            <Button fullWidth variant="secondary" href={CHECKOUT_BASIC} data-id="element-64" data-mp="l9aah9jvqkio">
              → QUIERO MI MEGA PACK
            </Button>
          </div>

          <div className="p-6 rounded-2xl bg-pistachio-100 border border-pistachio-400 flex flex-col justify-between" data-id="element-65" data-mp="uzlo5ntd882r">
            <div data-id="element-66" data-mp="78zmce9yfk17">
              <h2 className="text-lg font-bold text-ink mb-1 flex items-start gap-2" data-id="element-67" data-mp="7akha506l4zl">
                <span aria-hidden="true" data-id="element-68" data-mp="2bpwwymkf8dd">🏆</span> MEGA PACK + SISTEMA TOTAL
              </h2>
              <p className="text-pistachio-800 text-sm mb-4" data-id="element-69" data-mp="gbijchr272fj">
                6 Tomos + 6 Bonos + Cocina Impecable · La solución completa
              </p>
              <div className="flex items-baseline gap-2 mb-6" data-id="element-70" data-mp="bdpbzle0s2do">
                <span className="text-muted/70 line-through text-sm" data-id="element-71" data-mp="1ro1j5zf8v9n9">$71.000 ARS</span>
                <span className="text-3xl font-display font-bold text-ink" data-id="element-72" data-mp="1mpq6zi1h8n1v">
                  $27.990 <span className="text-sm text-muted font-sans" data-id="element-73" data-mp="kdwt6wmvilt3">ARS</span>
                </span>
              </div>
            </div>
            <Button fullWidth href={CHECKOUT_PREMIUM} data-id="element-74" data-mp="pade7hys0k1y">
              → QUIERO EL SISTEMA TOTAL
            </Button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted font-medium" data-id="element-75" data-mp="ycmqac9p0lhg">
          <span className="flex items-center gap-1" data-id="element-76" data-mp="1n5klxapmzfr">
            <span aria-hidden="true" data-id="element-77" data-mp="1ogl9o8uzr2n">🔒</span> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-78" data-mp="5p0hmpllyqnq">
            <span aria-hidden="true" data-id="element-79" data-mp="ank8n4f26smy">⚡</span> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-80" data-mp="alh65kwpz71c">
            <span aria-hidden="true" data-id="element-81" data-mp="fesi20ge2e04">🛡️</span> Garantía 7 días
          </span>
          <span className="flex items-center gap-1" data-id="element-82" data-mp="3e4snrgiejedz">
            <span aria-hidden="true" data-id="element-83" data-mp="3e1y25lnnjniz">💳</span> Mercado Pago · Tarjeta · Transferencia
          </span>
        </div>
      </div>
    </section>;
}